<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19UDvva/tc-custom/9781526728074.jpg?1728259236074" alt="This image is the cover for the book Archie Bowman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Archie Bowman
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1915, Archie Bowman, a philosophy professor at Princeton, was granted leave of absence to join the British army. He served in the HLI and was captured at the Battle of the Lys.Prison camp, though, turned out not to be the living death he expected: he was fluent in German and became the main go-between with camp authorities and British prisoners; he gave talks to hundreds of prisoners, and wrote up in verse form his account of the battle and his capture and two-day march into captivity. When he was transferred to another camp, his writings were confiscated; but in his new camp his responsibilities increased, and he became key negotiator and formed a bond with the Commandant, a fellow academic, who secured the release of his confiscated work, which, when completed, was published as prison camp verses.After the Armistice, he was posted to the British Army of the Rhine in Cologne, where he found his most interesting work in the service, interviewing German civilians wishing to travel into another Occupied Zone.Although Bowman didnt become a pacifist he was convinced more could be done to prevent wars; and he dedicated himself to the cause of peace and championed the ideal of the League of Nations, at the cost of his health.Based on the archived Bowman Papers, it is a fascinating story of a man of high principle and great depth of feeling who had the love and support of his wife Mabel.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hamish Ross
      </h2>
      
      <p class="authorDescription body article">Hamish Ross is the author of 'Paddy Mayne', the acclaimed biography of one of the revered figures in the SAS; 'Freedom in the Air', which was translated into Czech and for which he was awarded the Commemorative Medal by the Czech Republic; and 'From SAS to Blood Diamond Wars' with Fred Marafono. He lives with his wife in Glasgow.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a3ed2722